"use strict";
// export type Expect<T extends true> = T
// export type ExpectTrue<T extends true> = T
// export type ExpectFalse<T extends false> = T
// export type IsTrue<T extends true> = T
// export type IsFalse<T extends false> = T
Object.defineProperty(exports, "__esModule", { value: true });
exports.tryManyTimes = exports.safePipe = exports.safeTrySuccess = exports.safeTryFailure = void 0;
exports.tryAsync = tryAsync;
exports.trySync = trySync;
exports.safeTry = safeTry;
const safeTrySuccess = (result) => ({
    result,
    failed: false,
    success: true,
    error: null,
});
exports.safeTrySuccess = safeTrySuccess;
const safeTryFailure = (result, error) => ({
    result,
    failed: true,
    success: false,
    error,
    errorName: error === null || error === void 0 ? void 0 : error.name,
});
exports.safeTryFailure = safeTryFailure;
function tryAsync(tryFcn, onFailureReturn = false) {
    return async function safeTryExec(params = undefined) {
        try {
            const result = await tryFcn(params);
            return safeTrySuccess(result);
        }
        catch (error) {
            const result = typeof onFailureReturn === "function" ? onFailureReturn(error, params) : onFailureReturn;
            return safeTryFailure(result, error);
        }
    };
}
/*

  Write docs

  R.safeTry(() => {})({x: true});

*/
function trySync(tryFcn, onFailureReturn = false) {
    return function trySyncExec(params = undefined) {
        try {
            const result = tryFcn(params);
            return safeTrySuccess(result);
        }
        catch (error) {
            const result = typeof onFailureReturn === "function" ? onFailureReturn(params) : onFailureReturn;
            return safeTryFailure(result, error);
        }
    };
}
function safeTry(tryFcn, onFailureReturn = null) {
    // @ts-ignore: Unreachable code error
    return function safeTryExec(params = undefined) {
        try {
            const result = tryFcn(params);
            if (result instanceof Promise) {
                return result.then(safeTrySuccess).catch((error) => {
                    const result = typeof onFailureReturn === "function" ? onFailureReturn(error, params) : onFailureReturn;
                    return safeTryFailure(result, error);
                });
            }
            return safeTrySuccess(result);
        }
        catch (error) {
            const result = typeof onFailureReturn === "function" ? onFailureReturn(error, params) : onFailureReturn;
            return safeTryFailure(result, error);
        }
    };
}
const safePipe = (...fns) => (result = undefined) => fns.reduce(async (prevPromiseResult, fcn) => {
    const previousResult = await prevPromiseResult;
    if (previousResult.success)
        return await fcn(previousResult.result);
    return previousResult;
}, { result, failed: false, success: true, error: null });
exports.safePipe = safePipe;
const tryManyTimes = async (fcnToTry, params) => {
    const safeFcnToTry = safeTry(fcnToTry);
    const rOne = await safeFcnToTry(params);
    if (!rOne.error)
        return rOne;
    const rTwo = await safeFcnToTry(params);
    if (!rTwo.error)
        return rTwo;
    const rThree = await safeFcnToTry(params);
    if (!rThree)
        return rThree;
    const rFour = await safeFcnToTry(params);
    return rFour;
};
exports.tryManyTimes = tryManyTimes;
//# sourceMappingURL=safeTry.js.map